import { useContext } from "react";
import { EvaluationCreateFormContext } from "@/components/EvaluationCreateForm/contexts/EvaluationCreateForm/EvaluationCreateFormContext";

export function useEvaluationCreateForm() {
  const context = useContext(EvaluationCreateFormContext);

  if (!context) {
    throw new Error(
      "useEvaluationCreateForm should be used within the EvaluationCreateFormProvider provider."
    );
  }

  return context;
}
